import { Settings } from '@/contexts/Settings.types';
import { UserData } from '@/features/identity/identity.types';
import { useFetchData, usePostData } from '@/helpers/hooks';

//#region Commands
export const useLogout = () =>
  usePostData<boolean, unknown, unknown, unknown>({
    url: '/login/logout',
    options: {
      meta: {
        disableAutoInvalidate: true
      }
    }
  });
//#endregion

//#region Queries
export const useGetGlobalSettings = (isEnabled: boolean) =>
  useFetchData<Settings>(['globalSettings'], '/user/getglobalsettings', {
    enabled: isEnabled
  });

export const useGetUsers = () =>
  useFetchData<UserData[]>(['users'], '/user/GetUsers', {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
//#endregion
